import { useCallback, useState } from "react";

import { getDomainWithoutSuffix, getSubdomain } from "tldts";

import { SubDomainInfo } from "../types";
import env from "../util/env";

export default function useSubDomainInfo() {
  let subDomain: string | null;

  if (["work", "test", "demo", "production"].includes(env.NODE_ENV || "")) {
    subDomain = getSubdomain(window.location.origin);
  } else {
    subDomain = getDomainWithoutSuffix(window.location.origin);
  }

  const [subDomainInfo, _setSubDomainInfo] = useState<SubDomainInfo | undefined>(
    subDomain && window.localStorage.getItem(subDomain)
      ? JSON.parse(window.localStorage.getItem(subDomain) || "")
      : undefined
  );

  const setSubDomainInfo = useCallback((subDomainInfo?: SubDomainInfo) => {
    if (subDomain) {
      if (subDomainInfo) {
        window.localStorage.setItem(subDomain, JSON.stringify(subDomainInfo));
      } else {
        window.localStorage.removeItem(subDomain);
      }
      _setSubDomainInfo(subDomainInfo);
    }
  }, []);

  return [subDomainInfo, setSubDomainInfo] as const;
}
